import AlternateEmailIcon from '@mui/icons-material/AlternateEmail'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import { FormControlLabel, Grid } from '@mui/material'
import Lottie from 'lottie-react'
import { TypographyComponent } from 'src/components/Typography'
import styled, { css } from 'styled-components'
import theme, { techTheme } from '../../styles/theme'

export const ContainerFlex = styled('div')(
  () => css`
    display: flex;
    gap: ${theme.layout.gap.base * 10}rem;
    width: 100%;
    justify-content: center;

    @media (max-width: ${theme.screen.large}) {
      max-width: 100%;
    }
  `
)

export const Content = styled('div')(
  () => css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${theme.layout.gap.base * 5}rem;
    width: 70%;

    @media (max-width: ${theme.screen.large}) {
      width: 100%;
    }
  `
)

export const Title = styled('h1')(
  () => css`
    font-size: ${theme.typograph.fontsize.h8};
  `
)

export const GridEnd = styled(Grid)(
  () => css`
    width: 100%;
    display: grid;
    align-items: center;
    justify-content: flex-end;

    @media (max-width: ${theme.screen.small}) {
      justify-content: flex-start;
    }
  `
)

export const ContentFlex = styled('div')(
  () => css`
    width: 50%;
    flex-direction: column;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: ${theme.layout.gap.medium};

    @media (max-width: ${theme.screen.small}) {
      width: 100%;
    }
  `
)

export const LottieAnimation = styled(Lottie)(
  () => css`
    max-width: 70rem;
    min-width: 17.5rem;
  `
)

export const Info = styled('h1')(
  () => css`
    font-size: ${theme.typograph.fontsize.h8};
    color: ${theme.colors.primary.main70};
    text-align: center;
  `
)

export const InfoSocialName = styled('div')(
  () => css`
    && {
      font-size: ${theme.layout.iconSize.small};
      background-color: ${techTheme.colors.primary.main20};
      color: ${theme.colors.base.blue};
      border-radius: ${theme.layout.borderRadius.medium};
      display: flex;
      align-items: center;
      padding: ${theme.layout.padding.small};
      gap: ${theme.layout.gap.small};
    }
  `
)

export const InfoFlex = styled('div')(
  () => css`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;

    @media (max-width: ${theme.screen.small}) {
      flex-direction: column;
    }
  `
)

export const ModalBox = styled('form')(
  () => css`
    padding: ${theme.layout.padding.medium};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  `
)

export const Header = styled('div')(
  () => css`
    && {
      display: flex;
      flex-direction: row;
      width: 100%;
      justify-content: space-between;
    }
  `
)

export const ModalTitle = styled(TypographyComponent)(
  () => css`
    && {
      font-size: ${theme.typograph.fontsize.h8};
      font-weight: 700;
      color: ${theme.colors.primary.main};

      @media (max-width: ${theme.screen.medium}) {
        font-size: ${theme.typograph.fontsize.h4};
      }
    }
  `
)

export const FormControl = styled(FormControlLabel)(
  () => css`
    display: flex;
    align-items: center;
    width: 100%;
  `
)

export const Typograph = styled(TypographyComponent)(
  () => css`
    font-size: ${theme.typograph.fontsize.h8};
    text-transform: uppercase;
  `
)

export const WhatsApp = styled(WhatsAppIcon)(
  ({ theme }) => css`
    && {
      font-size: ${theme.layout.iconSize.medium};
      width: ${theme.layout.iconSize.medium};
      height: ${theme.layout.iconSize.medium};
    }
  `
)

export const Email = styled(AlternateEmailIcon)(
  ({ theme }) => css`
    && {
      font-size: ${theme.layout.iconSize.medium};
      width: ${theme.layout.iconSize.medium};
      height: ${theme.layout.iconSize.medium};
    }
  `
)

export const ModalDescription = styled(TypographyComponent)(
  () => css`
    && {
      font-size: ${theme.typograph.fontsize.h6};
      text-align: start;
      width: 100%;
      font-weight: 700;
      margin: ${theme.layout.margin.base * 6}rem 0 ${theme.layout.margin.medium}
        0;
    }
  `
)

export const ModalBoxButtons = styled('div')(
  () => css`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    gap: ${theme.layout.gap.medium};
    margin-top: ${theme.layout.margin.base * 6}rem;
  `
)

export const HelperText = styled('span')(
  () => css`
    font-size: 1rem;
  `
)
